import React, { Component, Fragment } from 'react';
import { View, TouchableOpacity } from 'react-native';
import ReactModal from 'react-modal';

import Colors from '../../config/Colors';

import Text from '../../react-component/textComponent';

import styles from './styles';
import { isMobile } from 'react-device-detect';

class ModalFiltro extends Component {
    state = {
        isOpen: false
    };

    componentDidMount() {
        this.setState({ isOpen: true });
    }

    closeModal = () => {
        if (!this.props.isSaveButtonLoading) {
            this.props.onClose();
        }
    };

    renderItem = (filtro, label) => {
        const { filtroAtual } = this.props;

        return (
            <TouchableOpacity onPress={() => this.props.changeFiltro(filtro)}>
                {filtro === filtroAtual[0] ? (
                    <View style={styles.selectedLine}>
                        <Text $bold style={styles.text}>
                            {label}
                        </Text>
                    </View>
                ) : (
                    <View style={styles.contentLine}>
                        <Text style={styles.text}>{label}</Text>
                    </View>
                )}
            </TouchableOpacity>
        );
    };

    render() {
        const { isOpen } = this.state,
            { left, top } = this.props;

        return (
            <Fragment>
                {!isMobile && (
                    <ReactModal
                        isOpen={isOpen}
                        onRequestClose={this.closeModal}
                        style={{
                            content: {
                                width: 170,
                                height: 135,
                                left: left,
                                top: top + 45,
                                right: 'auto',
                                bottom: 'auto',
                                padding: 0,
                                borderTopWidth: 0,
                                borderTopLeftRadius: 0,
                                borderTopRightRadius: 0,
                                borderColor: Colors.border
                            },
                            overlay: {
                                backgroundColor: Colors.transparent
                            }
                        }}
                    >
                        <div style={styles.container}>
                            {this.renderItem('todos', 'Todos')}
                            {this.renderItem('disponivel', 'Disponíveis')}
                            {this.renderItem('indisponivel', 'Indisponíveis')}
                        </div>
                    </ReactModal>
                )}
            </Fragment>
        );
    }
}

export default ModalFiltro;
